var _rect, _rect2, _path, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 117,
    viewBox: "0 0 139 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.77294,
    y: 42.8076,
    width: 112.338,
    height: 74.892,
    rx: 13.3736,
    transform: "rotate(-20 3.77294 42.8076)",
    fill: "#0066FF",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.77294,
    y: 42.8076,
    width: 112.338,
    height: 74.892,
    rx: 13.3736,
    transform: "rotate(-20 3.77294 42.8076)",
    fill: "white",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7816 76.689L53.8748 73.7433L55.2964 77.6491L42.277 82.3878L33.3375 57.8268L38.2637 56.0338L45.7816 76.689ZM54.4144 50.1554L63.3539 74.7165L58.4276 76.5095L49.4881 51.9484L54.4144 50.1554ZM82.085 67.8989L69.1643 60.2085L73.1473 71.1519L68.221 72.945L59.2816 48.3839L64.2078 46.5909L68.2165 57.6047L73.1455 43.3378L79.0923 41.1734L73.3895 57.0369L88.3133 65.632L82.085 67.8989ZM88.9876 42.0748L91.2288 48.2326L99.498 45.2229L100.92 49.1287L92.6505 52.1385L95.0198 58.6482L104.345 55.2543L105.805 59.2657L91.5536 64.4526L82.6013 39.8564L96.8523 34.6694L98.3123 38.6808L88.9876 42.0748Z",
    fill: "#0066FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.77294,
    y: 42.8076,
    width: 112.338,
    height: 74.892,
    rx: 13.3736,
    transform: "rotate(-20 3.77294 42.8076)",
    stroke: "#0066FF",
    strokeWidth: 5.34943
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTag);
export default __webpack_public_path__ + "static/media/likeTag.eddef65369a4b2f66ac2b73aa1e913c2.svg";
export { ForwardRef as ReactComponent };